import './signup.css';
import React, { useContext, useEffect, useState } from 'react';
import {Button, Form, Modal} from 'react-bootstrap';
import { LoadingSign } from "../Utility/loading-sign";
import { fetchSignup} from '../API/apiservice';
import { ModalApiErrorMessage } from '../Utility/errorMessage';

export const Signup = (props) => {
    //const [credential, setCredential] = useState({warehouse: 'AGR', customerNumber: '', email: '', password: '', confirmPassword: ''});
    const [credential, setCredential] = useState({customerNumber: '', email: '', password: '', confirmPassword: ''});
    const [signupError, setSignupError] = useState("");
    const [show, setShow] = useState(true);
    const handleClose = () => {setShow(false); window.location.href='../app/login'}
    const handleShow = () => setShow(true);
    const [validated, setValidated] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isApiError, setIsApiError] = useState(false);
    const warehouses = ['AGR', 'AMER', 'AWR', 'CRM', 'ECMM', 'EVN', 'GCT', 'GGA', 'GKC', 'GMN', 'GNC', 'GOH', 'GRO', 'GTN', 'GWAZ', 'HH', 'LOCK', 'LONG', 'LP', 
    'LPMS', 'MP', 'MPGA', 'MSCC', 'MSDEL', 'MSFM', 'MT', 'MWP', 'MWPID', 'MWPM', 'NASFD', 'NOQ', 'OLI', 'ONT', 'ORC', 'REX', 'RMS', 'RSFC', 'SC', 'TEU', 'THR', 'TOLE', 'WFP'];


    const handleInputChange = (event) => {
        setCredential({...credential, [event.target.name]: event.target.value});
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if(credential.password === credential.confirmPassword)
        {
            const form = event.currentTarget;
            if (form.checkValidity() === false) {
                event.stopPropagation();
            }
            else{
                const createAccount = async () => {
                    setIsLoading(true);
                    const data = await fetchSignup(credential);
                    if(Array.isArray(data) && data[0] == 'error')
                    {
                        setIsApiError(true);
                    }
                    else {
                      if(data.success)
                      {
                        window.location.href='../app/login'
                      }
                      else if(data.error)
                      {
                        setSignupError(data.error);
                      }
                    }
                    setIsLoading(false);
                  };
                  createAccount();
            }
            setValidated(true);
        }
    };


    return (
        <div className="signupPage">
        <LoadingSign isLoading={isLoading} />
        <Modal className="signupModal" backdrop="static" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Sign Up</Modal.Title>
            </Modal.Header>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Modal.Body>
            <ModalApiErrorMessage isApiError={isApiError}/>
            {signupError && <Form.Text className="errorMsg">*{signupError}<br/></Form.Text>}
            {/* <Form.Group className="mb-3" controlId="formWarehouse">
                <Form.Label>Warehouse</Form.Label>
                <Form.Select aria-label="Default select example" name="warehouse" value={credential.warehouse} onChange={handleInputChange} required>
                {
                    warehouses.map((warehouse, key) => (
                        <option value={warehouse} key={key}>{warehouse}</option>
                    ))                    
                }
                </Form.Select>
                </Form.Group> */}
            <Form.Group className="mb-3" controlId="formCustomerNumber">
                    <Form.Label>Customer Number</Form.Label>
                    <Form.Control name="customerNumber" placeholder="Enter customer number" value={credential.custNum} onChange={handleInputChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control type="email" name="email" placeholder="Enter email" value={credential.email} onChange={handleInputChange}required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password (8 or more characters)</Form.Label>
                    <Form.Control type="password" name="password" placeholder="Password" minLength="8" value={credential.password} onChange={handleInputChange}required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Confirm Password</Form.Label>
                    <Form.Control type="password" name="confirmPassword" placeholder="Confirm password" value={credential.confirmPassword} onChange={handleInputChange}required/>
                    {credential.password !== credential.confirmPassword && <span className='passwordMismathErrMsg'>*Passwords do not match.</span>}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" type="submit">
                    Submit
                </Button>
            </Modal.Footer>
            </Form>
        </Modal>
        </div>
    );
};